export enum PaymentRequestCalculationTypeEnum {
    RemainingBalance = 'remaining_balance',
    Total = 'total',
}